import { Plugins } from '@leverege/plugin';
import IntEditor from "./IntEditor.js";
import PercentEditor from "./PercentEditor.js";
import NumberEditor from "./NumberEditor.js";
import StringEditor from "./StringEditor.js";
import UnitEditor from "./UnitEditor.js";
import GeoPointEditor from "./GeoPointEditor.js";
import TimestampEditor from "./TimestampEditor.js";
import BooleanEditor from "./BooleanEditor.js";
import StringArrayEditor from "./StringArrayEditor.js";
import IntArrayEditor from "./IntArrayEditor.js";
import NumberArrayEditor from "./NumberArrayEditor.js";
import ValidatorSetup from "./validator/PluginSetup.js";
export default {
  install: opts => {
    Plugins.add('AttributeValueEditor', BooleanEditor);
    Plugins.add('AttributeValueEditor', GeoPointEditor);
    Plugins.add('AttributeValueEditor', IntArrayEditor);
    Plugins.add('AttributeValueEditor', IntEditor);
    Plugins.add('AttributeValueEditor', NumberArrayEditor);
    Plugins.add('AttributeValueEditor', NumberEditor);
    Plugins.add('AttributeValueEditor', PercentEditor);
    Plugins.add('AttributeValueEditor', StringArrayEditor);
    Plugins.add('AttributeValueEditor', StringEditor);
    Plugins.add('AttributeValueEditor', TimestampEditor);
    Plugins.add('AttributeValueEditor', UnitEditor);
    ValidatorSetup.install(opts);
  }
};